import { render, staticRenderFns } from "./query-ranking-settings-section.vue?vue&type=template&id=1a46a523&scoped=true"
import script from "./query-ranking-settings-section.vue?vue&type=script&lang=ts"
export * from "./query-ranking-settings-section.vue?vue&type=script&lang=ts"
import style0 from "./query-ranking-settings-section.vue?vue&type=style&index=0&id=1a46a523&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a46a523",
  null
  
)

export default component.exports